import { SearchBox } from '@fluentui/react-components';
import type { InputOnChangeData, SearchBoxChangeEvent } from '@fluentui/react-components';
import type { KeyboardEvent } from 'react';
import { useEffect, useRef } from 'react';

type TProps = {
  value: string;
  isOpen: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
};

const SelectItemDialogSearchBox = ({ value, isOpen, placeholder = 'Search', onChange }: TProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const timeoutId = window.setTimeout(() => {
      inputRef.current?.focus();
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [isOpen]);

  const handleChange = (_event: SearchBoxChangeEvent, data: InputOnChangeData) => {
    onChange(data.value);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Escape' || !value) return;

    event.preventDefault();
    event.stopPropagation();
    onChange('');
  };

  return (
    <SearchBox
      ref={inputRef}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      aria-label={placeholder}
      appearance="outline"
      className="mb-3 w-full"
    />
  );
};

export default SelectItemDialogSearchBox;
